const LayoutDefault = () => import('@/layout/Default');

const TopicList = () => import('@/views/Topic/List');

export default {
  path: '/catalogos',
  component: LayoutDefault,
  children: [
    {
      path: 'materias',
      name: 'Subject',
      component: TopicList,
      props: {
        entity: 'subject',
      },
    },
  ],
};
